import { OnboardingNotifications } from '../models/OnboardingNotifications';

export const showTagOnItemMenu = (
    onboardingNotifications: OnboardingNotifications | undefined,
    section: string,
    days?: number
): boolean => (onboardingNotifications ? onboardingNotifications.isTemporalNotificationVisible(section, days) : false);
